import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  @Input() visible: boolean;
  @Input() cover: boolean; // for full page cover
  @Input() text = '';
  @Input() elementCover = false; // for entry level cover

  ngOnInit(): void {
  }

}
